export const footerClick = {
    event: "footer_click",
    eventAction: "footer"
};
